export * from "./reducers"


// WEBPACK FOOTER //
// ./src/state/proposal/index.ts